// removed by extract-text-webpack-plugin
module.exports = {"follow-seller":"follow-seller___3vwbU","uppercase":"uppercase___3BCTO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FollowSeller/FollowSellerLink.scss
// module id = xSux
// module chunks = 46